import { useBillingCurrency } from "$global-providers/billing-provider/provider";
import { useMemo } from "react";
import { currencyFormatFor } from "./currency-formatter";

export default function useCurrencyFormat(
  overrideCurrency?: ReturnType<typeof useBillingCurrency>,
) {
  const billingCurrency = useBillingCurrency();
  const currency = overrideCurrency ?? billingCurrency;

  return useMemo(() => currencyFormatFor(currency), [currency]);
}
